import React, {Component, PropTypes} from 'react';
import {
  Modal,
  Button,
} from '@sketchpixy/rubix';

class SelectTypeModal extends Component {
  componentDidMount() {
    Messenger.options = {
      theme: 'flat',
    };
  }

  hide = () => {
    this.props.hideModal();
  };

  overwrite = () => {
    this.props.overwrite(this.props.selectedAssetVersionId, (err, result) => {
      if (err) {
        Messenger().post({
          type: 'error',
          message: 'Error while copying. please try later.',
          showCloseButton: true,
        });
        this.hide();
        this.props.copyFilesCallback();
      } else {
        Messenger().post({
          type: 'success',
          message: 'files copied successfully!',
          showCloseButton: true,
        });
        this.hide();
        this.props.copyFilesCallback();
      }
    });
  };

  deleteAndPush = () => {
    this.props.deleteAndPush(this.props.selectedAssetVersionId, (err, result) => {
      if (err) {
        Messenger().post({
          type: 'error',
          message: 'Error while copying. please try later.',
          showCloseButton: true,
        });
        this.hide();
        this.props.copyFilesCallback();
      } else {
        Messenger().post({
          type: 'success',
          message: 'files copied successfully!',
          showCloseButton: true,
        });
        this.hide();
        this.props.copyFilesCallback();
      }
    });
  };

  render() {
    return (
        <div>
          <Modal show={this.props.showModal} onHide={this.hide}>
            <Modal.Header closeButton>
              <Modal.Title>Alert!</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              [Asset Version {this.props.currentVersionCode}] has file(s).
              <br />
              <br />
              <br />
              <Button
                  bsStyle="brownishgray"
                  bsSize="large"
                  block
                  onClick={this.overwrite}>
                Overwrite
              </Button>
              <Button
                  bsStyle="brownishgray"
                  bsSize="large"
                  block
                  onClick={this.deleteAndPush}>
                Delete all exist files and push newly
              </Button>
              <br />
            </Modal.Body>
            <Modal.Footer />
          </Modal>
        </div>
    );
  }
}

SelectTypeModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  hideModal: PropTypes.func.isRequired,
  selectedAssetVersionId: PropTypes.number.isRequired,
  overwrite: PropTypes.func.isRequired,
  deleteAndPush: PropTypes.func.isRequired,
  currentVersionCode: PropTypes.number.isRequired,
  copyFilesCallback: PropTypes.func.isRequired,
};

export default SelectTypeModal;


// WEBPACK FOOTER //
// ./src/component/SelectTypeModal.js